// extracted by mini-css-extract-plugin
export default {"tooltip":"tableIcon_tooltip__diZi3","container":"tableIcon_container__L4qkL"};